// extracted by mini-css-extract-plugin
module.exports = {"homepage":"FirstFilters_homepage__2T-Ht","bigButton":"FirstFilters_bigButton__2NUpQ","zoomHover":"FirstFilters_zoomHover__2884y"};